import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Game, Category } from '../types';
import { FeaturedGame } from '../types/game';
import './Home.css';
import SEO from '../components/SEO';
import { featuredGames, categories } from '../data/staticData';

declare const adConfig: any;
declare const adBreak: any;
declare const gtag: any;

interface FeaturedGameWithUrlkey extends FeaturedGame {
  urlkey?: string;
}

interface GameWithUrlkey extends Game {
  urlkey?: string;
}

// 最近玩过的游戏组件
const RecentGames: React.FC = () => {
  const [recent, setRecent] = useState<{id: number, title: string, thumbnailUrl: string, urlkey?: string}[]>([]);
  useEffect(() => {
    const stored = localStorage.getItem('recentGames');
    if (stored) setRecent(JSON.parse(stored));
  }, []);
  if (recent.length === 0) return null;
  return (
    <div className="recent-games">
      <h3>Recently Played</h3>
      <div className="recent-games-list">
        {recent.map(game => (
          <Link to={`/game/${game.urlkey}`} key={game.id} className="recent-game-item">
            <img src={game.thumbnailUrl} alt={game.title} width={48} height={48} />
            <span>{game.title}</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

const Home: React.FC = () => {
  const handleRewardAd = () => {
    
      adBreak({
            type: "reward",  // ['start', 'pause', 'next', 'browse', 'reward', 'preroll']
            name: "rewardcontinue",
            beforeReward: (showAdFn: any) => {
                showAdFn();
            },
            adDismissed: () => {
              console.log("Ad dismissed");
            },
            adViewed: () => {
              console.log("Ad viewed completely");
            },
            beforeAdBreak: () => { /* 暂停游戏 */ }, 
              // 广告播放后的回调，游戏应恢复
            afterAdBreak: () => { /* 恢复游戏 */ },
              // **关键：广告失败或结束后的回调**
            adBreakDone: (placementInfo: any) => {
                // placementInfo 中包含广告是否成功播放的信息
                // 检查 adBreakDone 的参数，通常会包含一个 `reason` 字段
                const failureReason = (placementInfo.reason || 'Unknown failure') + (placementInfo.breakStatus || "");
                if (typeof gtag === 'function') {
                  gtag('event', failureReason, {});
                }
              }
        });
  };

  return (
    <>
      <SEO 
        title="Free Online Games"
        description="Play the best free online games on RandPlays. Enjoy a huge collection of popular games that you can play on your browser."
      />
      <div className="home">
        {/* 最近玩过的游戏展示区 */}
        <RecentGames />
        {/* Featured Games Section */}
        <section className="featured-games">
          <div className="games-grid">
            {featuredGames.map((game: FeaturedGameWithUrlkey) => (
              <Link to={`/game/${game.urlkey}`} key={game.id} className="game-card">
                <div className="thumbnail-container">
                  <img 
                    src={game.thumbnailUrl} 
                    alt={game.title} 
                    className="game-thumbnail"
                  />
                  <div className="game-title">{game.title}</div>
                </div>
              </Link>
            ))}
          </div>
        </section>

        {/* Categories Section */}
        <section className="categories-list">
          {categories.filter(x=>x.id<=12).map((category: Category) => (
            <Link to={`/category/${category.id}`} key={category.id} className="category-list-item">
              <img 
                src={`/cicon/${category.name}.svg`} 
                alt={category.name} 
                className="category-icon"
                width={32}
                height={32}
                loading="lazy"
              />
              <span className="category-name">{category.name} Games</span>
            </Link>
          ))}
        </section>

        <section className="site-intro">
          <h2>Welcome to RandPlays</h2>
          <div className="site-intro-content">
            <p>
              Here, you can discover thousands of carefully selected games, from classic arcade to the latest hot games.
              We are committed to providing you with the best gaming experience, no download required, start your gaming adventure now!
            </p>
          </div>
          <div className="features-grid">
            <div className="feature-item">
              <h3>Free Games</h3>
              <p>All games are completely free, no download required, open your browser and play</p>
            </div>
            <div className="feature-item">
              <h3>Massive Selection</h3>
              <p>Thousands of carefully selected games, covering action, puzzle, strategy and more</p>
            </div>
            <div className="feature-item">
              <h3>Real-time Updates</h3>
              <p>Weekly updates of new games, always keeping the latest and hottest game content</p>
            </div>
          </div>
        </section>

        <div className="reward-ad-container" style={{ textAlign: 'center', padding: '40px 0' }}>
          <button 
            onClick={handleRewardAd}
            style={{
              padding: '12px 24px',
              fontSize: '1.1rem',
              fontWeight: 'bold',
              color: '#fff',
              backgroundColor: '#00b2ff',
              border: 'none',
              borderRadius: '8px',
              cursor: 'pointer',
              boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
              transition: 'transform 0.2s, background-color 0.2s'
            }}
            onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.05)'}
            onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1)'}
          >
            Watch Reward Ad
          </button>
        </div>
      </div>
    </>
  );
};

export default Home; 